/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formatters.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Formatter functions for MOH Sources module.
    Handles date formatting, file size formatting, etc.
────────────────────────────────────────────────────────────────*/

/**
 * Format date value for display
 */
export function formatDate(value: unknown): string {
  if (!value) {
    return '-';
  }

  const date =
    value instanceof Date
      ? value
      : typeof value === 'string'
        ? new Date(value)
        : new Date(String(value));

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  const formatter = new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return formatter.format(date);
}

/**
 * Format file size in bytes to human-readable string
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

/**
 * Format file size in MB (for display in file list)
 */
export function formatFileSizeMB(bytes: number): string {
  return (bytes / 1024 / 1024).toFixed(2) + ' MB';
}

